import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { SimVarFormBuilder } from '../../../_form-utils/sim-var-form-builder';
import { BaseObjectFormGroupWrapper } from '../../../_form-utils/base-object-form-group-wrapper';
import { FuelGasFlare } from '../../../_models/_unit-operations/fuel-gas/fuel-gas-flare';
import { FuelGasMaterialStream } from '../../../_models/_streams/fuel-gas-material-stream';

@Component({
  selector: 'sob-fuel-gas-flare',
  templateUrl: './fuel-gas-flare.component.html',
  styleUrls: ['./fuel-gas-flare.component.css'],
})
export class FuelGasFlareComponent implements OnInit {
  @Input() unitOperation: FuelGasFlare;
  @Input() formGroupWrapper: BaseObjectFormGroupWrapper;
  inletStream: FuelGasMaterialStream;
  compositionArray = this.fb.array([]);

  constructor(private fb: UntypedFormBuilder, private svfb: SimVarFormBuilder) {}

  ngOnInit(): void {
    const { ownerCase } = this.unitOperation;
    const inletStreams = ownerCase.filterFuelGasMaterialStreams((s: FuelGasMaterialStream) => {
      return s.outletUnitOperationId === this.unitOperation.id;
    });

    if (inletStreams.length) {
      this.inletStream = inletStreams[0];
    }
    this.addControls();
    this.formGroupWrapper.storeOriginalValue();
  }

  addControls() {
    this.propertyWindowFormGroup.addControl('name', this.fb.control(this.unitOperation.name));
    this.propertyWindowFormGroup.addControl('flowrate', this.svfb.control(this.unitOperation.flowrate, true));
    this.propertyWindowFormGroup.addControl(
      'fuelGasEmissionFactor',
      this.svfb.control(this.unitOperation.fuelGasEmissionFactor, true)
    );
    this.propertyWindowFormGroup.addControl('ghgEmissions', this.svfb.control(this.unitOperation.ghgEmissions, true));

    this.getComposition();
  }

  getComposition() {
    if (this.inletStream) {
      this.propertyWindowFormGroup.addControl('compositionUnit', this.fb.control(this.inletStream.composition[0].unit));
      let total = 0;
      for (let i = 0; i < this.inletStream.composition.length; i++) {
        const element = this.inletStream.composition[i];
        total += element.convertToCaptureUnit(true);
        this.compositionArray.push(this.fb.control({ value: element.value, disabled: true }));
      }
      this.propertyWindowFormGroup.addControl('composition', this.compositionArray);
      this.propertyWindowFormGroup.addControl('total', this.fb.control(total));
      this.propertyWindowFormGroup.controls['total'].disable();
    }
  }

  get propertyWindowFormGroup() {
    return this.formGroupWrapper.getFormGroup();
  }
}
